import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {SessionService} from '../services/session.service';
import {GrowlService} from '../services/growl.service';

@Injectable({
  providedIn: 'root'
})
export class SuperheroGuard implements CanActivate {
  constructor(
    public session: SessionService,
    public growl: GrowlService
  ) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.session.superhero) {
      this.growl.error('Non autorisé');
      return false;
    }
    return true;
  }
  
}
